module.exports = __webpack_public_path__ + "static/media/rules_mma.b5c5b1c9.png";